import React, { Component } from 'react'
import {Link} from 'gatsby'
import TextLoop from "react-text-loop";
import rawEmojis from '../../static/emojis/emojis'
import Layout from '../components/layout'
import RandQuote from '../components/randomQuote'
import Head from '../components/head'
import * as indexStyle from './pageStyles/index-style.module.scss'

export default class IndexPage extends Component {

    render() {
        return (
            <Layout>
                <Head title="Home"/>
                <div className={indexStyle.content}>
                
                <div  style={{marginTop:15}}>
                    <TextLoop springConfig={{ stiffness: 180, damping: 8 }}>
                        <div>
                            <h2>As-salamu alaykum{" "}
                            <span role="img" aria-label="tada">{rawEmojis.smile+rawEmojis.smile+rawEmojis.smile}</span>
                            </h2>
                        </div>
                        
                        <div>
                            <h2>Hello There{" "}
                            <span role="img" aria-label="wave">{rawEmojis.wave+rawEmojis.wave+rawEmojis.wave}</span>
                            </h2>
                        </div>

                        <div>
                            <h2>Good Day{" "}
                            <span role="img" aria-label="wave">{rawEmojis.fire+rawEmojis.fire+rawEmojis.fire}</span>
                            </h2>
                        </div>
                    </TextLoop>
                </div>
                
                <h3 style={{marginTop:15, letterSpacing:1.5, wordSpacing:5, alignSelf:'center'}}>Dev Journal is the Internet Home for my Noteworthy Journals and writings on anything that I think worthy of writing it down.</h3>
                
                <p style={{marginTop:15, alignSelf:'center', fontSize: 18, fontWeight: 'bold'}}><Link to="/about">more about me here</Link></p>
                

                <div style={{marginTop:15, alignSelf:'center'}}>
                    <RandQuote/>
                </div>
                
                
                </div>
            </Layout>
        )
    }
}

//export default IndexPage;
